import { useContext } from "react";
import { LatestOrderContext } from "./LatestOrderProvider";
import { PatientOrder } from "src/api/types";

export function useLatestOrder<T>(selector: (order: PatientOrder) => T) {
  const order = useContext(LatestOrderContext);

  if (order == null) {
    return null;
  }

  return selector(order);
}
